// src/odoo/transactions_dashboard/components/TransactionsDashboardFilterBar.tsx
// All comments are in English.

import React from "react";
import { Switch } from "@/components/ui/switch";

export interface TransactionsDashboardFilterState {
  startDate: string; // YYYY-MM-DD
  endDate: string;   // YYYY-MM-DD
  companyId?: number;
  activeOnly?: boolean;
}

interface TransactionsDashboardFilterBarProps {
  value: TransactionsDashboardFilterState;
  onChange: (next: TransactionsDashboardFilterState) => void;
}

const TransactionsDashboardFilterBar: React.FC<
  TransactionsDashboardFilterBarProps
> = ({ value, onChange }) => {
  const handleStartDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange({
      ...value,
      startDate: e.target.value,
    });
  };

  const handleEndDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange({
      ...value,
      endDate: e.target.value,
    });
  };

  const handleCompanyChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const raw = e.target.value;

    // "" means "All companies" → undefined (backend sees no filter)
    const nextCompanyId = raw === "" ? undefined : Number(raw);

    onChange({
      ...value,
      companyId: nextCompanyId,
    });
  };

  const handleActiveOnlyChange = (checked: boolean) => {
    onChange({
      ...value,
      activeOnly: checked,
    });
  };

  // Convert undefined → "" so dropdown shows "All"
  const companySelectValue =
    value.companyId === undefined ? "" : String(value.companyId);

  return (
    <section className="flex flex-wrap gap-4 items-end">
      {/* Start Date */}
      <div className="flex flex-col gap-1">
        <label className="text-sm font-medium">Start date</label>
        <input
          type="date"
          className="border rounded px-3 py-1 text-sm"
          value={value.startDate}
          onChange={handleStartDateChange}
        />
      </div>

      {/* End Date */}
      <div className="flex flex-col gap-1">
        <label className="text-sm font-medium">End date</label>
        <input
          type="date"
          className="border rounded px-3 py-1 text-sm"
          value={value.endDate}
          onChange={handleEndDateChange}
        />
      </div>

      {/* Company Select (Dropdown) */}
      <div className="flex flex-col gap-1">
        <label className="text-sm font-medium">Company ID (optional)</label>
        <select
          className="border rounded px-3 py-1 text-sm min-w-[160px]"
          value={companySelectValue}
          onChange={handleCompanyChange}
        >
          <option value="">All</option>
          <option value="1">Forida</option>
          <option value="2">OpenBIM</option>
        </select>
      </div>

      <div className="flex items-center gap-3 rounded-md border px-3 py-2">
        <Switch
          checked={value.activeOnly ?? false}
          onCheckedChange={handleActiveOnlyChange}
        />
        <div className="flex flex-col">
          <span className="text-sm font-medium">Active licenses only</span>
          <span className="text-xs text-muted-foreground">
            Limit product rankings to active licenses only.
          </span>
        </div>
      </div>
    </section>
  );
};

export default TransactionsDashboardFilterBar;
